import React, { useRef, useState } from 'react';
import HamburgerMenuLinks from './HamburgerMenuLinks';
import useClickOutside from '../../../hooks/useClickOutside';

const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const handleBlur = event => {
    if (
      !event.currentTarget.contains(event.relatedTarget) &&
      event.relatedTarget !== null
    ) {
      setIsOpen(false);
    }
  };

  useClickOutside(containerRef, isOpen, () => setIsOpen(false));

  return (
    <div
      onBlur={handleBlur}
      ref={containerRef}
      className="vads-u-display--flex vads-u-justify-content--center user-nav vads-u-align-items--center mobile"
    >
      {/* eslint-disable-next-line @department-of-veterans-affairs/prefer-button-component */}
      <button
        data-testid="menu-toggle-dropdown-mobile"
        className={isOpen ? 'is--open nav__btn' : 'nav__btn is--menu'}
        aria-controls="menu"
        aria-expanded={isOpen}
        aria-haspopup="true"
        onClick={() => {
          setIsOpen(prev => !prev);
        }}
        type="button"
      >
        {isOpen ? 'Close' : 'Menu'}
        <va-icon
          icon={isOpen ? 'close' : 'menu'}
          size={2}
          aria-hidden="true"
          z-index="-1"
          class="nav__user-btn-icon"
        />
      </button>
      <div
        className={`${
          !isOpen ? 'vads-u-display--none' : 'is--shown'
        } nav__full-width`}
        id="menu"
        data-testid="menu-toggle-dropdown-mobile-list"
      >
        <ul className="nav__user-list nav__dropdown">
          <HamburgerMenuLinks closeMenu={() => setIsOpen(false)} />
        </ul>
      </div>
    </div>
  );
};

export default HamburgerMenu;
